import React from 'react';
import styles from './CustomPagination.module.css';

function CustomPagination({
  page = 1,
  pageSize = 15,
  totalPages = 1,
  totalRecords = 0,
  onPageChange,
  onRowsPerPageChange,
  pageSizeOptions = [15, 25, 50, 100],
}) {
  return (
    <div className={styles.paginationContainer}>
      {/* Left: Rows per page */}
      <div className={styles.rowsPerPageSection}>
        <span className={styles.label}>Rows per page</span>
        <select
          value={pageSize}
          onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          className={styles.select}
        >
          {pageSizeOptions.map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </div>

      {/* Right: Page X of Y + arrows */}
      <div className={styles.navigationSection}>
        <span className={styles.pageInfo}>
          Page {page} out of {totalPages}
        </span>
        <button
          type="button"
          title="Previous"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1, pageSize)}
          className={`${styles.navButton} ${page <= 1 ? styles.disabled : ''}`}
        >
          ‹
        </button>
        <button
          type="button"
          title="Next"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1, pageSize)}
          className={`${styles.navButton} ${page >= totalPages ? styles.disabled : ''}`}
        >
          ›
        </button>
      </div>
    </div>
  );
}

export default CustomPagination;
